import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Diff2Html from 'diff2html';
import { Trans, withTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import AppModal from '../../../components/Modal';
import ApiV2ModelContext from '../../../contexts/ApiV2ModelContext';
import Icon from '../../../components/Icon';
import BranchExistsError from '../../../errors/BranchExistsError';
export const withAutoFixesForPullRequestModal = (WrappedComponent) => {
    var _a;
    return withTranslation()((_a = class AutoFixesForPullRequesModal extends React.Component {
            constructor() {
                super(...arguments);
                this.state = {
                    open: false,
                    files: [],
                    autoFixesForPR: {},
                    prCreated: false,
                    showBranchExistsAlert: false,
                    pullRequestTitle: '',
                    pullRequestBranchName: '',
                    disableCreateButton: true,
                    overrideBranch: false,
                    loading: false,
                    prSuccessMessage: '',
                };
                this.handleCloseModal = () => {
                    this.setState({ open: false });
                };
                this.handleClick = (autoFixesForPR, disableCreateButton = false) => {
                    this.setState({
                        open: true,
                        files: autoFixesForPR.files,
                        autoFixesForPR,
                        pullRequestTitle: autoFixesForPR.pullRequestTitle,
                        pullRequestBranchName: autoFixesForPR.pullRequestBranchName,
                        disableCreateButton,
                    });
                };
                this.handleGeneratePR = async () => {
                    const { t } = this.props;
                    const { autoFixesForPR, pullRequestTitle, pullRequestBranchName, overrideBranch, showBranchExistsAlert } = this.state;
                    try {
                        this.setState({
                            loading: true,
                        });
                        const response = await this.context.generatePullRequestFromDiff({ ...autoFixesForPR, pullRequestTitle, pullRequestBranchName, overrideDestinationBranch: overrideBranch });
                        this.setState({
                            prCreated: response.generatePullRequestFromDiff?.status,
                            showBranchExistsAlert: false,
                            prSuccessMessage: t(showBranchExistsAlert ? 'pullRequestWasUpdated' : 'pullRequestWasCreated'),
                            loading: false,
                        });
                        this.handleCloseModal();
                    }
                    catch (error) {
                        if (error instanceof BranchExistsError) {
                            this.setState({
                                loading: false,
                                showBranchExistsAlert: true,
                                overrideBranch: true,
                            });
                        }
                    }
                };
                this.handleChangeTitle = (event) => {
                    this.setState({
                        pullRequestTitle: event.target.value,
                    });
                };
                this.handleChangeBranch = (event) => {
                    this.setState({
                        pullRequestBranchName: event.target.value,
                    });
                };
                this.toggleOverrideBranch = () => {
                    this.setState((prevState) => ({
                        overrideBranch: !prevState.overrideBranch,
                    }));
                };
            }
            renderModal() {
                const { files, prCreated, showBranchExistsAlert, autoFixesForPR, disableCreateButton, loading } = this.state;
                const { t } = this.props;
                // @todo: Verify if we don't need all the commented type incompatible properties.
                const config = {
                    //inputFormat: 'json',
                    drawFileList: false,
                    //fileListToggle: false,
                    //fileListStartVisible: false,
                    //fileContentToggle: false,
                    matching: 'lines',
                    outputFormat: 'line-by-line',
                    //synchronisedScroll: true,
                    //highlight: true,
                    renderNothingWhenEmpty: false,
                    maxLineSizeInBlockForComparison: 100,
                };
                return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, size: "xl", modalClassName: "repositories-modal", contentClassName: "repositories-modal__content", children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('autoFixModalHeader') }), _jsx(ModalBody, { children: _jsxs("div", { className: "container reports mt-3", children: [_jsxs("form", { className: 'pb-2', children: [_jsxs("p", { children: [_jsx("label", { htmlFor: "pullRequestTitle", children: t('pullRequestTitle') }), _jsx("input", { type: "text", id: "pullRequestTitle", className: "form-control" //+ (browser.greaterThan.small ? ' form-control-lg' : '')}
                                                        , placeholder: t('pullRequestTitle'), defaultValue: autoFixesForPR ? autoFixesForPR.pullRequestTitle : '', onChange: this.handleChangeTitle, required: true, autoFocus: true })] }), _jsxs("p", { children: [_jsx("label", { htmlFor: "pullRequestBranchName", children: t('pullRequestBranchName') }), _jsx("input", { type: "text", id: "pullRequestBranchName", className: "form-control" //+ (browser.greaterThan.small ? ' form-control-lg' : '')}
                                                        , placeholder: t('pullRequestBranchName'), defaultValue: autoFixesForPR ? autoFixesForPR.pullRequestBranchName : '', onChange: this.handleChangeBranch, required: true, autoFocus: true })] })] }), files.length && files.map((file) => (_jsxs("div", { className: "report-detail__item", id: file.path, children: [_jsxs("h3", { className: "report-detail__file-path pl-0", children: [_jsx("small", { className: "text-muted", children: _jsx("span", { className: "badge badge-pill badge-primary ml-3", children: file.fixTool }) }), _jsx("bdi", { id: "report-path", children: file.path })] }), _jsx("div", { id: "code-diff", dangerouslySetInnerHTML: { __html: Diff2Html.html(file.fixDiff, config) } })] }, file.path))), showBranchExistsAlert && _jsx("div", { className: "alert alert-warning", children: _jsxs("div", { className: "d-flex", children: [_jsx(Icon, { name: "exclamation-triangle mr-3" }), _jsx("div", { className: "w-100", children: _jsxs(Trans, { i18nKey: "overrideBranch", children: ["These changes will update an existing branch.", _jsx("br", {}), "If you\u2019d prefer to create a new branch, please update the name field. Otherwise, click ", _jsx("strong", { children: "Generate Pull Request" }), "."] }) })] }) }), !prCreated && (_jsx("div", { className: "text-right", children: _jsxs("button", { className: "btn btn-primary", onClick: this.handleGeneratePR, disabled: disableCreateButton, children: [loading && _jsx(Icon, { name: 'spinner', spin: true, className: 'mr-2' }), t('generatePullRequest')] }) })), !prCreated && disableCreateButton && (_jsxs("div", { className: "text-right", children: [t('featureAvailableInPro'), _jsx(Link, { to: "/settings/billing", children: "PRO" })] }))] }) })] }));
            }
            render() {
                return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onShowDiffClick: this.handleClick, prSuccessMessage: this.state.prSuccessMessage }), this.state.open && _jsx(AppModal, { children: this.renderModal() })] }));
            }
        },
        _a.contextType = ApiV2ModelContext,
        _a));
};
